import React from 'react';
import ModelsAPI from '../../api/models';
import type { ImageSize } from '../../api/settings';
import { Badge } from '../ui';
import { listedSizes, sameSize } from '../modals/CarouselSizeField';

/**
 * "carousel size" on a model whose registry sizes include the carousel's. It
 * asks the registry for this one model's sizes (answers are cached per model);
 * a model that lists none, or a registry that cannot be read, gets no mark.
 */
const CarouselMark: React.FC<{ model: string; size: ImageSize }> = ({ model, size }) => {
  const [makes, setMakes] = React.useState(false);
  const { width, height } = size;

  React.useEffect(() => {
    let cancelled = false;
    setMakes(false);
    ModelsAPI.getModelConstraints(model, 'image')
      .then((constraints) => {
        if (!cancelled) setMakes(listedSizes(constraints).some((known) => sameSize(known, { width, height })));
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [model, width, height]);

  return makes ? <Badge variant="blue">carousel size</Badge> : null;
};

export default CarouselMark;
